module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1026.24ce42db.png";